export default "__VITE_ASSET__BtunZLuh__"